import humps from 'humps';

/**
 * Snakelize Hash includes(or not) fileData recursively
 * @param {*} obj
 * @return Object
 */
export const snakelizeHashR = obj => {
  const newObj = {};

  Object.keys(obj).forEach(key => {
    const newKey = humps.decamelize(key);

    // 下層のObjectのタイプによって再帰的に処理
    if (obj[key] instanceof File) {
      // typeof File === 'object' なので先に処理
      newObj[newKey] = obj[key];
    } else if (typeof obj[key] === 'object') {
      if (Array.isArray(obj[key])) {
        newObj[newKey] = obj[key].map(x => {
          return snakelizeHashR(x);
        });
      } else {
        // ただのObject
        newObj[newKey] = snakelizeHashR(obj[key]);
      }
    } else {
      // not Iteratable (String, Integer, etc.)
      newObj[newKey] = obj[key];
    }
  });

  return newObj;
};
